import {createFormActionTypes} from "../../../../shared/ts/helpers/create_form_action_types";
import {createFormActions} from "../../../../shared/ts/helpers/create_form_actions";

const ASSIGN_BUILDING_FORM = "offer-building/ASSIGN_BUILDING_FORM";
export const assignBuildingFormTypes = createFormActionTypes(ASSIGN_BUILDING_FORM);
export const assignBuildingFormActions = createFormActions(assignBuildingFormTypes);
